import React from 'react';
import ShopListing from '../components/shop/ShopListing';

// /products?category=<nombre> — la tienda filtrada por categoría
const CategoryShop = () => <ShopListing />;

export default CategoryShop;
